import {Component} from '@angular/core';
import {Field} from '../../../../model/field.model';
import {ActivatedRoute, Router} from '@angular/router';
import {Tree} from '../../../../model/tree.model';
import {StateService} from '../../../../state.service';
import {Line} from '../../../../model/line.model';

@Component({
    selector: 'app-add-tree',
    templateUrl: './add-tree.component.html',
    styleUrls: ['./add-tree.component.css'],
    standalone: false
})
export class AddTreeComponent {
  tree = new Tree();
  submitted = false;
  field: Field;
  line: Line;
  treeTypes = ['Atlas-Zeder', 'Buche', 'Flaumeiche', 'Hänge-Birke', 'Haselbaum', 'Haselstrauch', 'Kiefer', 'Steineiche',
    'Stieleiche', 'Winterlinde'];
  truffleTypes = ['Burgunder', 'Perigordtrüffel', 'Wintertrüffel', 'Frühlingstrüffel', 'Teertrüffel', 'Grosssporigetrüffel'];

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.field && !this.stateService.line) {
      this.router.navigate( ['field']);
    }
    this.field = this.stateService.field;
    this.line = this.stateService.line;
    if (this.line.trees.length > 0 && this.line.trees[this.line.trees.length - 1].truffleType) {
      this.tree.truffleType = this.line.trees[this.line.trees.length - 1].truffleType;
      this.tree.createdAt = this.line.trees[this.line.trees.length - 1].createdAt;
    }
  }

  onSubmit() {
    this.tree.id = this.line.trees.length + 1;
    this.field.lines[this.line.id - 1].trees.push({...this.tree});
    this.stateService.addTree(this.field);
    this.tree = this.line.trees[this.line.trees.length - 1];

    this.submitted = true;
    this.router.navigate(['field/' + this.field.id + '/line/' + this.line.id + '/tree/' + this.tree.id]);
  }

}
